import script from "./Reminder.vue?vue&type=script&setup=true&lang=js"
export * from "./Reminder.vue?vue&type=script&setup=true&lang=js"

import "./Reminder.vue?vue&type=style&index=0&id=0115489d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0115489d"]])

export default __exports__